var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2083 13.2611C21.1553 13.1632 20.0966 13.3757 19.1629 13.8723C18.2293 14.369 17.4614 15.1281 16.9541 16.0561",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5934 14.1595C17.0432 13.7038 16.4027 13.3697 15.714 13.1794C15.0254 12.9891 14.3042 12.9468 13.5981 13.0552C12.8919 13.1637 12.2167 13.4206 11.6169 13.8088C11.0172 14.1971 10.5065 14.708 10.1184 15.3078",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1583 18.2768C11.832 18.6401 12.5926 18.8111 13.3569 18.771C14.1212 18.7308 14.8598 18.4812 15.4917 18.0493",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2157 15.1666C11.2523 14.1307 11.8597 12.7418 11.9165 11.2775C11.9869 9.90876 12.2458 8.55629 12.6857 7.2583",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5034 20.3659C18.5034 20.3659 11.9168 26.1726 4.33345 18.7517C4.06316 18.451 3.87919 18.0829 3.801 17.6862C3.72281 17.2896 3.75332 16.8791 3.88928 16.4984C4.97262 13.7575 6.05595 8.76338 10.5409 4.36505L13.6068 2.28505C13.8114 2.13468 14.0624 2.06098 14.3158 2.07682C14.5693 2.09266 14.8091 2.19703 14.9934 2.37172L17.1601 4.39755C17.2633 4.49844 17.3453 4.61893 17.4013 4.75195C17.4572 4.88496 17.4861 5.02782 17.4861 5.17213C17.4861 5.31645 17.4572 5.4593 17.4013 5.59232C17.3453 5.72533 17.2633 5.84582 17.1601 5.94672C16.2609 6.86755 14.6143 7.89672 13.0001 5.42672",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 21.1665C17.3334 21.1665 18.3084 21.394 18.9475 23.929",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.e1d3305a0958711a3bad1af5d0600bf7.svg";
export { ForwardRef as ReactComponent };